export default "__VITE_ASSET__vrbTZMyG__"